import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";

const CurrencyList = ({ currency }) => {
  const { t } = useTranslation("currenciesPage");

  if (!currency) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (currency.length === 0) {
    return <Alert severity="warning">{t("currency.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable width="290" size="14">
        <StyledTableHead scroll="auto" col="2">
          <div>
            {t("currency.table.currency")}
          </div>
          <div>
            {t("currency.table.type")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {currency && currency.map((value, key) => (
            <StyledTableRow key={key} scroll="auto" col="2">
              <StyledCol>
                {value.asset}
              </StyledCol>
              <StyledCol>
                {value.type}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default CurrencyList;